import script from "./CompletedPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedPlans.vue?vue&type=script&setup=true&lang=js"

import "./CompletedPlans.vue?vue&type=style&index=0&id=452f4bb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452f4bb2"]])

export default __exports__